export default {
  gnm12b: require('@/assets/images/pixso-automotive-official/series-products/gnm12-b.jpg'),
  gnm12d: require('@/assets/images/pixso-automotive-official/series-products/gnm12-d.jpg'),
  gnm13: require('@/assets/images/pixso-automotive-official/series-products/gnm13.jpg'),
  gnm14: require('@/assets/images/pixso-automotive-official/series-products/gnm14.jpg'),
  cx005: require('@/assets/images/pixso-automotive-official/series-products/cx005.jpg'),
  im13m: require('@/assets/images/pixso-automotive-official/series-products/im13-m.jpg'),
  im16m: require('@/assets/images/pixso-automotive-official/series-products/im16-m.jpg'),
  im18m: require('@/assets/images/pixso-automotive-official/series-products/im18-m.jpg'),
  im21: require('@/assets/images/pixso-automotive-official/series-products/im21.jpg'),
  ib11: require('@/assets/images/pixso-automotive-official/series-products/ib11.jpg'),
  inm13s1: require('@/assets/images/pixso-automotive-official/series-products/inm13-s1.jpg'),
  inm14: require('@/assets/images/pixso-automotive-official/series-products/inm14.jpg'),
  p21s: require('@/assets/images/pixso-automotive-official/series-products/p21s.jpg')
}
